import React from 'react';
import { useAppSelector } from '../../hooks/defaultHooks';
import { getIsSuperAdmin } from '../../selectors/selectors';
import useDocumentTitle from '../../hooks/useDocumentTitle';
import cls from './ApplicationSettingsPage.module.scss';
import { Outlet } from 'react-router-dom';
import ApplicationSettingsNavigation from '../../features/layout/ApplicationSettingsNavigation';

/**
 * Mirrors apisupport: the `GET`s behind this page carry no role gate, so anyone signed in may
 * look; every write — the settings themselves, the language CRUD, the announcements — is gated on
 * superadmin (`getOrdinalRole() > 0`).
 *
 * The read-only mode is a single `fieldset[disabled]` around the outlet instead of a `disabled`
 * prop threaded through every block: it disables each nested input, select and button natively, so
 * a block added later is covered without touching it.
 */
const ApplicationSettingsPage = () => {
  const isSuperAdmin = useAppSelector(getIsSuperAdmin);
  useDocumentTitle('Application Settings');
  return (
    <div data-testid="settings-container" className="h-100 py-3 px-5 overflow-auto">
      <h2 className={cls.Title} data-testid="settings-title">
        Settings
      </h2>
      {!isSuperAdmin && (
        <p className={cls.ReadOnlyNotice} data-testid="settings-readonly-notice">
          Read-only: only a superadmin can change these settings
        </p>
      )}
      <div>
        <ApplicationSettingsNavigation />
        <fieldset className={cls.Fieldset} disabled={!isSuperAdmin} data-testid="settings-fieldset">
          <Outlet />
        </fieldset>
      </div>
    </div>
  );
};

export default ApplicationSettingsPage;
